import { buildKioskAuthHeaders } from './api';

export async function downloadAuthenticatedFile(url, filename) {
  const response = await fetch(url, { headers: buildKioskAuthHeaders(), cache: 'no-store' });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.error || 'Export impossible. Vérifiez votre connexion et vos autorisations.');
  }
  const objectUrl = URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    // Let the browser begin reading the download before releasing its object URL.
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  }
}
